import React from 'react';

import SelectFormField from '@components/form-fields/SelectFormField';
import WidgetPaper from '@components/widgets/display-widget/WidgetPaper';
import WidgetSection from '@components/widgets/display-widget/WidgetSection';

import { FormValues, MedicalDetails } from '../types';

import { getIn, useFormikContext } from 'formik';
import { makeStyles } from 'tss-react/mui';

type Props = {
  disabledForm: boolean;
  medicalClassOptions: Record<string, string>;
  medicalLevelOptions: Record<string, string>;
};

const useStyles = makeStyles()(() => ({
  fieldRow: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    gap: 12,
    marginBottom: 12
  }
}));

const NSSF_OPTIONS: Record<string, string> = {
  YES: 'Yes',
  NO: 'No'
};

const MedicalDetailsWidgetAtom: React.FC<Props> = ({
  disabledForm,
  medicalClassOptions,
  medicalLevelOptions
}) => {
  const { classes } = useStyles();

  const { values, errors, touched, setFieldValue, handleBlur } =
    useFormikContext<FormValues>();

  // ⬇️ CHANGE THIS - Add explicit type
  const medical: MedicalDetails = values.medicalDetails || {
    medicalClassId: '',
    levelId: '',
    nssf: ''
  };

  const setMedical = (name: string, v: unknown) =>
    setFieldValue(`medicalDetails.${name}`, v);

  const err = (field: string) =>
    getIn(touched, `medicalDetails.${field}`)
      ? (getIn(errors, `medicalDetails.${field}`) as string) || ''
      : '';

  return (
    <WidgetPaper>
      <WidgetSection
        title="Medical Details"
        hasTitleSpecificDesign={false}
        useSeparator={false}
      >
        <div className={classes.fieldRow}>
          <SelectFormField
            name="medicalDetails.medicalClassId"
            title="Class*"
            placeholder="Class"
            value={medical.medicalClassId || ''}
            onBlur={(_, e) => handleBlur(e)}
            error={err('medicalClassId')}
            onChange={(v) => setMedical('medicalClassId', v)}
            disabled={disabledForm}
            selectOptions={medicalClassOptions}
            material
          />

          <SelectFormField
            name="medicalDetails.levelId"
            title="Level*"
            placeholder="Level"
            value={medical.levelId || ''}
            onBlur={(_, e) => handleBlur(e)}
            error={err('levelId')}
            onChange={(v) => setMedical('levelId', v)}
            disabled={disabledForm}
            selectOptions={medicalLevelOptions}
            material
          />

          <SelectFormField
            name="medicalDetails.nssf"
            title="NSSF*"
            placeholder="NSSF"
            value={medical.nssf || ''}
            onBlur={(_, e) => handleBlur(e)}
            error={err('nssf')}
            onChange={(v) => setMedical('nssf', v)}
            disabled={disabledForm}
            selectOptions={NSSF_OPTIONS}
            material
          />
        </div>
      </WidgetSection>
    </WidgetPaper>
  );
};

export { MedicalDetailsWidgetAtom };
